module.exports = __webpack_public_path__ + "static/img/naturalCircle5h.4bbf873.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle5h.svg
// module id = Rkro
// module chunks = 1